import { render, staticRenderFns } from "./FooterHelpPreview.vue?vue&type=template&id=4ac948c9&scoped=true"
import script from "./FooterHelpPreview.vue?vue&type=script&lang=js"
export * from "./FooterHelpPreview.vue?vue&type=script&lang=js"
import style0 from "./FooterHelpPreview.vue?vue&type=style&index=0&id=4ac948c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac948c9",
  null
  
)

export default component.exports